import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from '../theme';
import { useResponsive } from '../hooks/useResponsive';
import { getApiUrl } from '../config';

const ChangePasswordPage: React.FC = () => {
  const { isMobile } = useResponsive();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(getApiUrl('/api/auth/change-password'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ newPassword })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Error al cambiar contraseña');
      }

      navigate('/owner/reservations');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error desconocido');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '14px 16px',
    backgroundColor: theme.colors.background,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: theme.borderRadius.input,
    color: theme.colors.text,
    fontSize: theme.fonts.sizeBody,
    fontFamily: theme.fonts.body,
    outline: 'none',
    boxSizing: 'border-box',
    marginBottom: '12px',
  };

  const buttonStyle: React.CSSProperties = {
    width: '100%',
    padding: '14px',
    backgroundColor: theme.colors.primary,
    color: '#000',
    border: 'none',
    borderRadius: theme.borderRadius.button,
    fontSize: theme.fonts.sizeBody,
    fontWeight: 'bold',
    cursor: loading ? 'not-allowed' : 'pointer',
    fontFamily: theme.fonts.body,
    opacity: loading ? 0.7 : 1,
    transition: 'all 0.2s ease',
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: isMobile ? '20px 16px' : theme.spacing.lg,
      backgroundColor: theme.colors.background,
    }}>
      <div style={{
        width: '100%',
        maxWidth: isMobile ? '100%' : '500px',
        margin: '0 auto',
      }}>
        <div style={{
          backgroundColor: theme.colors.surface,
          borderRadius: theme.borderRadius.card,
          padding: isMobile ? '24px 20px' : theme.spacing.lg,
          boxShadow: theme.colors.shadow,
          border: `2px solid ${theme.colors.primary}`,
        }}>
          <h2 style={{
            color: theme.colors.text,
            fontFamily: theme.fonts.heading,
            fontSize: '1.5rem',
            marginBottom: '8px',
            textAlign: 'center',
          }}>
            Cambiar Contraseña
          </h2>
          <p style={{
            color: theme.colors.textSecondary,
            fontFamily: theme.fonts.body,
            fontSize: theme.fonts.sizeSmall,
            marginBottom: '24px',
            textAlign: 'center',
          }}>
            Por seguridad, debes cambiar tu contraseña temporal antes de continuar.
          </p>

          <form onSubmit={handleSubmit}>
            <input
              type="password"
              placeholder="Nueva contraseña"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={inputStyle}
              required
              minLength={6}
            />

            <input
              type="password"
              placeholder="Confirmar contraseña"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={inputStyle}
              required
              minLength={6}
            />

            {error && (
              <div style={{
                color: theme.colors.danger,
                fontSize: theme.fonts.sizeSmall,
                marginBottom: '12px',
                textAlign: 'center',
              }}>
                {error}
              </div>
            )}

            <button type="submit" style={buttonStyle} disabled={loading}>
              {loading ? 'Guardando...' : 'Cambiar Contraseña'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
